import React, { FC } from 'react';
import classnames from 'classnames';
import { Printer } from 'react-bootstrap-icons';
import { Trans } from 'react-i18next';

import { IProduct } from 'api/types';
import { useNotifications } from 'hooks';

import { ReactComponent as MessageQuestionIcon } from 'assets/messages-question.svg';

import styles from 'theme/components/wise/WisePdpActionButton/WisePdpActionButton.module.scss';

export type WiseActionButtonProps =
  | {
      variant: 'print';
      className?: string;
      onClick?: () => void;
    }
  | {
      variant: 'askProduct';
      product?: IProduct;
      className?: string;
      onClick?: () => void;
    };

const WiseActionButton: FC<WiseActionButtonProps> = (props) => {
  const { showWarningMessage } = useNotifications();

  const rootClass = classnames(styles.actionButton, props.className);

  if (props.variant === 'print') {
    return (
      <div
        className={classnames(rootClass, 'StylePath-Components-Wise-WiseActionButton-print')}
        onClick={() => (props.onClick ? props.onClick() : showWarningMessage('Funkcja niezaimplementowana'))}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            props.onClick ? props.onClick() : showWarningMessage('Funkcja niezaimplementowana');
          }
        }}
        role="button"
        tabIndex={0}>
        <Printer />
        <span>
          <Trans>Drukuj</Trans>
        </span>
      </div>
    );
  }

  return (
    <div
      className={classnames(rootClass, 'StylePath-Components-Wise-WiseActionButton-askProduct')}
      onClick={props.onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          props.onClick?.();
        }
      }}
      role="button"
      tabIndex={0}>
      <MessageQuestionIcon />
      <span>
        <Trans>Zapytaj o produkt</Trans>
      </span>
    </div>
  );
};

export default WiseActionButton;
